import { forwardRef } from 'react';
import { pathgen } from 'object-path-generator';
import { Button, MenuItem, SplitButton } from 'seagull';
import { useEventReporter } from "../../event-reporter";
import { useRedirectToProposal } from "../../hooks/useCreateAgreement";
import { useOpenNewProposal } from "../../hooks/useOpenNewProposal";
import styles from "./CreateProposalButton.module.scss";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const CreateProposalButtonTestIds = pathgen('CreateProposalButtonTestIds');
export const CreateProposalButton = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    text = 'Create proposal',
    hideTemplatePicker = false
  } = props;
  const {
    reportButtonClick
  } = useEventReporter();
  const {
    openCreationModal
  } = useRedirectToProposal();
  const {
    isLoadingProposalTemplates,
    hasProposalTemplates,
    openNewProposal: _openNewProposal,
    openSelectProposalTypeModal
  } = useOpenNewProposal();
  function openNewProposal() {
    reportButtonClick('topbar-new-agreement-btn');
    _openNewProposal();
  }
  const openNewProposalFromDraft = async () => {
    reportButtonClick('topbar-new-agreement-btn');
    await openCreationModal();
  };
  const onNewTemplate = async () => {
    openSelectProposalTypeModal('template');
  };
  return !hideTemplatePicker && hasProposalTemplates ? /*#__PURE__*/_jsx(SplitButton, {
    label: text,
    testId: CreateProposalButtonTestIds.SplitButton.Root(),
    onClick: openNewProposal,
    popperClassName: styles.popper,
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(MenuItem, {
        onClick: onNewTemplate,
        testId: CreateProposalButtonTestIds.SplitButton.NewTemplateOption(),
        children: "Use a template"
      }), /*#__PURE__*/_jsx(MenuItem, {
        onClick: openNewProposalFromDraft,
        testId: CreateProposalButtonTestIds.SplitButton.NewProposalOption(),
        children: "Start from scratch"
      })]
    })
  }) : /*#__PURE__*/_jsx(Button, {
    testId: CreateProposalButtonTestIds.Button(),
    onClick: openNewProposal,
    ref: ref,
    loading: isLoadingProposalTemplates,
    children: text
  });
});